import { Fab, styled } from '@mui/material';

import { ReactNode, useEffect, useState } from 'react';

import { Menu } from '@mui/icons-material';
import { useLocation } from 'react-router';

import { Navigation } from './components/Navigation';
import { Separator } from './components/Separator';

const StyledSidebar = styled('aside')<{ opened: boolean }>(
  ({ theme, opened }) => ({
    width: opened ? '80%' : 0,
    height: '100%',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    // gap: theme.spacing(10),
    // color: '#7a7a7a',
    borderRight: '1px solid #e3e3e3',
    background: '#f9f9f9',
    position: 'absolute',
    zIndex: 100,
    overflow: 'hidden',
    transition: '.3s all',
    whiteSpace: 'nowrap',
    '@media screen and (min-width: 768px)': {
      position: 'relative',
      // padding: `${theme.spacing(5)} ${theme.spacing(4)}`,
      width: theme.spacing(75),
      flex: `0 0 ${theme.spacing(75)}`,
    },
  })
);

const SidebarToggle = styled(Fab)(({ theme }) => ({
  display: 'flex',
  position: 'absolute',
  right: theme.spacing(4),
  bottom: theme.spacing(4),
  zIndex: 200,
  svg: {
    fill: '#1b1b1b',
  },
  '@media screen and (min-width: 768px)': {
    display: 'none',
  },
}));

export type SidebarProps = {
  children: ReactNode;
};

export const Sidebar = ({ children }: SidebarProps) => {
  const location = useLocation();
  const [opened, setOpened] = useState(false);

  const toggle = () => {
    setOpened((prev) => !prev);
  };

  useEffect(() => {
    setOpened(false);
  }, [location.pathname]);

  return (
    <>
      <SidebarToggle color="primary" onClick={toggle}>
        <Menu />
      </SidebarToggle>
      <StyledSidebar opened={opened}>{children}</StyledSidebar>
    </>
  );
};

Sidebar.Navigation = Navigation;
Sidebar.Separator = Separator;
